<template>
  <v-btn
    depressed
    class="yellow-button"
    :to="to"
    :disabled="disabled"
    @click="doClick($event)"
  >
    <slot></slot>
  </v-btn>
</template>
<script>
export default {
  data() {
    return {
      // ...
    };
  },
  methods: {
    doClick(event) {
      this.$emit("click", event);
    }
  },
  props: ["disabled", "to"]
};
</script>
<style lang="sass" scoped>
.yellow-button.v-btn:not(.v-btn--round)
  justify-self: center
  height: 64px
  width: 337px
  border-radius: 4px
  background-color: #FCBE32 !important
  margin-bottom: 114px

.yellow-button.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).theme--light
  background-color: rgba(252, 190, 50, .25) !important

.yellow-button
  ::v-deep .v-btn__content
    color: $color-pt-royal
    font-family: "Source Sans Pro"
    font-size: 22px
    font-weight: bold
    letter-spacing: 0
    line-height: 28px
    text-align: center
    text-transform: none
</style>
